export default __webpack_public_path__ + "static/david-tsai-fd646a4c6d812fbb7258efca4627e9ee.png";